var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.667,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7736",
    d: "M3.639 24H23.06a3.414 3.414 0 003.606-3.593 3.536 3.536 0 00-.5-1.78L16.439 1.814a3.584 3.584 0 00-3.11-1.813 3.584 3.584 0 00-3.11 1.813L.492 18.627a3.627 3.627 0 00-.5 1.78A3.459 3.459 0 003.639 24zm9.694-8.473a1.1 1.1 0 01-1.191-1.154l-.165-6.857a1.267 1.267 0 011.357-1.286 1.293 1.293 0 011.356 1.319l-.2 6.857a1.05 1.05 0 01-1.157 1.121zm0 4.352a1.533 1.533 0 01-1.555-1.451 1.517 1.517 0 011.555-1.484 1.508 1.508 0 011.522 1.484 1.461 1.461 0 01-1.522 1.451z",
    fill: "#ff3b30"
  })));
}
export default SvgErrorIos;